import {
	Container,
	Breakpoints,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	TextAlignment,
	CTA,
	Spinner,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { HuchaValues } from '../../models/hucha-values';
import { HuchaDisclaimer1Content } from '../disclaimers/hucha-disclaimer1-content';
import { useHuchaPdfGenerator } from '../../hooks/use-hucha-pdf-generator';
import { HuchaPDFContent } from '../pdf/hucha-pdf-content';
import { PopupHuchaBonusCard } from './popup-card/popup-hucha-bonus-card/popup-hucha-bonus-card';

export const HuchaBonusPopup: React.FC<{
	huchaValues: HuchaValues | null;
}> = ({ huchaValues }) => {
	const targetRefPDF = React.useRef<HTMLDivElement>(null);
	const { handlePdfDownloadClick, isDownloading, isPdfReady } = useHuchaPdfGenerator(huchaValues, targetRefPDF);

	return (
		<>
			<Container
				padding={{
					right: {
						[Breakpoints.default]: ContainerPadding.grid001,
						[Breakpoints.b560]: ContainerPadding.grid002,
						[Breakpoints.b960]: ContainerPadding.grid001,
					},
					bottom: ContainerPadding.dynamic0200,
					left: {
						[Breakpoints.default]: ContainerPadding.grid001,
						[Breakpoints.b560]: ContainerPadding.grid002,
						[Breakpoints.b960]: ContainerPadding.grid001,
					},
				}}
				horizontalAlign={'center'}
				wrap={'always'}
			>
				<PopupHuchaBonusCard dineroHucha={huchaValues?.dineroHucha ?? ''} />
				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
				>
					<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
						Por formar parte del Club Volkswagen, cada mes acumulas saldo que podrás utilizar para tu próximo
						Volkswagen.
					</Text>
					<Container
						padding={{
							top: {
								[Breakpoints.default]: ContainerPadding.dynamic0200,
								[Breakpoints.b560]: ContainerPadding.dynamic0150,
							},
						}}
						verticalAlign={'center'}
						horizontalAlign={'center'}
					>
						<CTA
							tag="button"
							aria-label="Descargar ahorro acumulado"
							size="large"
							onClick={handlePdfDownloadClick}
							emphasis="primary"
							disabled={isDownloading}
							stretchContent={{ [Breakpoints.default]: true, [Breakpoints.b560]: false }}
							icon={isDownloading ? <Spinner /> : undefined}
						>
							<Text bold>{isDownloading ? 'Descargando' : 'Descargar ahorro acumulado'}</Text>
						</CTA>
					</Container>
					<Container
						wrap={'always'}
						padding={{
							top: {
								[Breakpoints.default]: ContainerPadding.dynamic0200,
								[Breakpoints.b560]: ContainerPadding.dynamic0150,
							},
						}}
						verticalAlign={'center'}
						horizontalAlign={'center'}
					>
						<Text appearance={TokenTextAppearance.bigcopy100} textAlign={TextAlignment.center} bold>
							¿Cómo puedes utilizarlo?
						</Text>
						<Text appearance={TokenTextAppearance.bigcopy100} textAlign={TextAlignment.center}>
							Muy sencillo. Si ha llegado el momento de estrenar Volkswagen de nuevo, descárgate aquí tu ahorro
							acumulado y muéstralo en tu punto de venta para poder disfrutarlo.
						</Text>
					</Container>
					<Container
						wrap={'always'}
						padding={{
							top: {
								[Breakpoints.default]: ContainerPadding.dynamic0200,
								[Breakpoints.b560]: ContainerPadding.dynamic0150,
							},
						}}
						verticalAlign={'center'}
						horizontalAlign={'center'}
					>
						<HuchaDisclaimer1Content />
					</Container>
				</Container>
			</Container>
			{isPdfReady && <HuchaPDFContent targetRef={targetRefPDF} huchaValues={huchaValues} />}
		</>
	);
};
